import React, { useState } from "react";
import styles from "./ticket-page-ticket-header.module.scss";
import { SupportAgentTicket } from "@src/types/support";
import { Title } from "@src/components/atoms/title/title";
import expandHeaderIconBlue from "@src/assets/svg/expand-arrows-blue.svg";
import collapseHeaderIconBlue from "@src/assets/svg/collapse-arrows-blue.svg";
import { useI18N } from "@src/language/language-context";
const cssClassName = "ticket-page-chat-header";

interface TicketPageChatHeaderProps {
  ticket: SupportAgentTicket;
}

export const TicketPageChatHeader = ({ ticket }: TicketPageChatHeaderProps) => {
  const i18n = useI18N();
  const [collapsed, setCollapsed] = useState(false);

  const texts = {
    supportDetails: i18n("modules.ticketPageChatHeader.supportDetails"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div
        className={styles[`${cssClassName}__container`]}
        style={{ height: collapsed ? 24 : "fit-content" }}
      >
        <div>
          <div className={styles[`${cssClassName}__header`]}>
            {!collapsed ? (
              <>
                <div className={styles[`${cssClassName}__title-block`]}>
                  <span className={styles[`${cssClassName}__label`]}>
                    {texts.supportDetails}
                  </span>
                  <Title text={ticket.title} />
                  <p className={styles[`${cssClassName}__description`]}>
                    {ticket.description}
                  </p>
                </div>
              </>
            ) : (
              <p className={styles[`${cssClassName}__title`]}>{ticket.title}</p>
            )}
            <button
              className={styles[`${cssClassName}__toggle`]}
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? (
                <img
                  className={styles[`${cssClassName}__toggle-icon`]}
                  src={expandHeaderIconBlue}
                  alt="Expand header"
                />
              ) : (
                <img
                  className={styles[`${cssClassName}__toggle-icon`]}
                  src={collapseHeaderIconBlue}
                  alt="Collapse header"
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
